import * as React from 'react';

import type { DegreePlan_LearnerAdmissionStatus as LearnerAdmissionStatus } from '__generated__/graphql-types';

import ReadyForFullDegreeDefault from 'bundles/degree-home/components/v3-dpm/components/HelpTips/ReadyForFullDegreeDefault';
import ReadyForFullDegreePBAOnly from 'bundles/degree-home/components/v3-dpm/components/HelpTips/ReadyForFullDegreePBAOnly';
import { useProgramVariation } from 'bundles/degree-home/components/v3-dpm/context/ProgramVariation';
import { isFCND } from 'bundles/degree-home/components/v3-dpm/lib/otherUtils';

const TipReadyForFullDegree: React.VFC<{ learnerAdmissionStatus: LearnerAdmissionStatus }> = ({
  learnerAdmissionStatus,
}) => {
  const { supportsPBAOnly } = useProgramVariation();
  if (!isFCND(learnerAdmissionStatus)) {
    return null;
  }

  if (supportsPBAOnly) {
    return <ReadyForFullDegreePBAOnly />;
  } else {
    return <ReadyForFullDegreeDefault />;
  }
};

export default TipReadyForFullDegree;
